import globalActions from '@/actions'
import $command from '@/utils/command'
const state = {
    ids:[],
    keys:[]
}

const mutations = {
  update: (state, data) => {
    state.ids = data.ids
    state.keys = data.keys
	
	globalActions.setGlobalState({
		feature: state
	});
  }
}

const actions = {
    async get({ commit }) {
		if (state.ids.length == 0) {
			const result = await $command.execute({
				api: "/core-api/sys/getRoleFeatureList",
				parameter: {}
			})
			let ids  = [];
			let keys = [];
			result.data.forEach(e=>{
			    ids.push(e.key)
			    keys.push(e.value)
			})
			commit('update',{ids, keys})
		}
		return state;
    },
}
export default {
    namespaced: true,
	mutations,
    state,
    actions
}